"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const types_1 = require("../../uiNodes/tapes/generated-supplemental-tape/types");
exports.artifactType = 'generatedSupplementalTape';
// The persisted config is the operation task PLUS the required `passThrough`
// flag. Shared with the UI-layer converter output so both stay in sync.
exports.NodeConfigSchema = types_1.IntermediateRecordConfigSchema;
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map